import * as _utils2 from "@noble/curves/abstract/utils";
var _utils = _utils2;
try {
  if ("default" in _utils2) _utils = _utils2.default;
} catch (e) {}
import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _isHexDew } from "./isHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isBytesEqual = void 0;
  const utils_1 = _utils;
  const toBytes_js_1 = _toBytesDew();
  const isHex_js_1 = _isHexDew();
  function isBytesEqual(a_, b_) {
    const a = (0, isHex_js_1.isHex)(a_) ? (0, toBytes_js_1.toBytes)(a_) : a_;
    const b = (0, isHex_js_1.isHex)(b_) ? (0, toBytes_js_1.toBytes)(b_) : b_;
    return (0, utils_1.equalBytes)(a, b);
  }
  exports.isBytesEqual = isBytesEqual;
  //# sourceMappingURL=isBytesEqual.js.map
  return exports;
}